/*
 * Butonul „Adaugă și aparatul de citire" de pe pagina de produs.
 * Adaugă varianta aparatului în coș și deschide sidecart-ul, exact ca
 * formularul de produs (product-form.js).
 */
if (!customElements.get('device-offer')) {
  class DeviceOffer extends HTMLElement {
    constructor() {
      super();
      this.querySelector('.device-offer__add')?.addEventListener('click', (event) => this.add(event.currentTarget));
    }

    async add(button) {
      if (button.disabled) return;
      const drawer = document.querySelector('cart-drawer');
      const error = this.querySelector('.device-offer__error');
      const label = button.textContent;

      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      error.hidden = true;

      const body = new FormData();
      body.append('id', button.dataset.variantId);
      body.append('quantity', '1');
      if (drawer) {
        body.append('sections', drawer.getSectionsToRender().map((section) => section.id));
        body.append('sections_url', window.location.pathname);
      }

      try {
        const response = await fetch(routes.cart_add_url, {
          method: 'POST',
          headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
          body,
        });
        const state = await response.json();
        if (state.status) {
          error.textContent = state.description || state.message || '';
          error.hidden = !error.textContent;
          return;
        }
        if (drawer) {
          drawer.renderContents(state);
        } else {
          window.location.href = routes.cart_url;
        }
      } catch (e) {
        error.textContent = 'Nu am putut adăuga aparatul. Încearcă din nou.';
        error.hidden = false;
      } finally {
        button.disabled = false;
        button.removeAttribute('aria-busy');
        button.textContent = label;
      }
    }
  }

  customElements.define('device-offer', DeviceOffer);
}
